import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { post } from '../../controllers/apiController';
import { useEffect } from 'react';

const SifreDegistir = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState('');

    useEffect(() => {
        document.title = "Şifre Değiştir | LEVELUP CRM";
    }, []);

    const changePassword = async () => {
        if (newPassword !== newPasswordConfirm) {
            toast.error('Yeni şifreniz ile onay şifreniz eşleşmiyor');
            return;
        }

        try {
            await post('users/change-password', {
                nowPassword: currentPassword,
                newPassword: newPassword
            });
            toast.success('Şifre başarıyla değiştirildi');
        } catch (error) {
            toast.error(error.response.data.message || 'Şifre değiştirirken bir hata oluştu');
        }
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content without-header nxl-full-content">
                    <div className="main-content d-flex">
                        <div className="content-sidebar content-sidebar-md ps" data-scrollbar-target="#psScrollbarInit">
                            <div className="content-sidebar-header bg-white sticky-top hstack justify-content-between">
                                <h4 className="fw-bolder mb-0">Profil Ayarları</h4>
                                <a href="javascript:void(0);" className="app-sidebar-close-trigger d-flex">
                                    <i className="feather-x"></i>
                                </a>
                            </div>
                            <div className="content-sidebar-body">
                                <ul className="nav flex-column nxl-content-sidebar-item">
                                    <li className="nav-item">
                                        <a className="nav-link" href="./my-account">
                                            <i className="feather-user"></i>
                                            <span>Profil Bilgileri</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link active" href="./change-password">
                                            <i className="feather-lock"></i>
                                            <span>Şifre Değiştir</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                                <div className="ps__thumb-x" tabIndex="0" style={{ left: 0, width: 0 }}></div>
                            </div>
                            <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                                <div className="ps__thumb-y" tabIndex="0" style={{ top: 0, height: 0 }}></div>
                            </div>
                        </div>
                        <div className="content-area ps ps--active-y" data-scrollbar-target="#psScrollbarInit">
                            <div className="content-area-header bg-white sticky-top">
                                <div className="page-header-left">
                                    <a href="javascript:void(0);" className="app-sidebar-open-trigger me-2">
                                        <i className="feather-align-left fs-24"></i>
                                    </a>
                                </div>
                                <div className="page-header-right ms-auto">
                                    <div className="d-flex align-items-center gap-3 page-header-right-items-wrapper">
                                        <button href="javascript:void(0);" onClick={changePassword} className="btn btn-primary successAlertMessage">
                                            <i className="feather-edit me-2"></i>
                                            <span>Şifre Değiştir</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="content-area-body">
                                <div className="card mb-0">
                                    <div className="card-body">
                                        <div className="mb-5">
                                            <div className="mb-3">
                                                <label className="form-label">Mevcut Şifreniz</label>
                                                <input type="password" className="form-control" placeholder="Mevcut Şifreniz" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Yeni Şifreniz</label>
                                                <input type="password" className="form-control" placeholder="Yeni Şifreniz" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Yeni Şifreniz Tekrar</label>
                                                <input type="password" className="form-control" placeholder="Yeni Şifreniz Tekrar" value={newPasswordConfirm} onChange={(e) => setNewPasswordConfirm(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default SifreDegistir;
